import { Injectable, Injector, inject, isDevMode } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { VERSION } from '../../../../environments/version';
import { AppGlobalsModule } from '../../../app-globals.module';
import { UserService } from '../../../user/user.service';

/**
 * Stamps this bundle's build version on every request to the cms api, so the save
 * endpoints can REFUSE a critically-stale client (426 - RejectCriticallyStaleClient):
 * the nihul's version watch is cooperative, a wedged tab might never run it, and the
 * server-side gate is what makes "critical" actually mean it. The header name carries
 * no cms path (the cardinal rule); the match is against the server-revealed cmsApiLink,
 * resolved LAZILY through the injector - UserService pulls HttpClient, and resolving it
 * while the interceptor chain is being built would be a DI cycle. No stored cms address
 * (or an unrelated url) = the request passes untouched; a header-less client is let
 * through server-side by design (clients predating the header must not be locked out).
 */
@Injectable()
export class NihulClientVersionInterceptor implements HttpInterceptor {
    private _injector = inject(Injector);

    intercept(request: HttpRequest<unknown>, next: HttpHandler) {
        if (AppGlobalsModule.isServer || isDevMode()) {
            //server: the nihul never runs there, and the ssr must not touch user/localStorage
            //state. Dev: a dev bundle's version.ts is generated ad-hoc and usually STALE
            //(ng serve never regenerates it), so stamping it would trip the critical 426 gate
            //on every dev save the moment a threshold is stored - the same reason the
            //version WATCH is isDevMode-off. No header = the server passes the request.
            return next.handle(request);
        }
        const apiLink = this._injector.get(UserService).cmsApiLinkStored();
        if (!apiLink || !request.url.toLowerCase().includes(apiLink.toLowerCase())) {
            return next.handle(request);
        }
        return next.handle(request.clone({ headers: request.headers.set('yeshiva-nihul-client-version', VERSION) }));
    }
}
